<template>

  <!-- Studios Block -->
  <page-block
    v-if="channel"
    :class="classes"
    class="studios-block"
    :bg-color="blockColor"
    wrapper-class="ibs-pt bs-pb"
    :bg-file="studio && studio.bgFile"
    :text-color="textColor || 'white'">

    <channel-content
      :value="channel"/>

  </page-block>

</template>

<script>

  import {mapGetters} from 'vuex';
  import PageBlock from '@src/components/page/page-block';
  import ChannelContent from '@src/components/content/channel-content';

  export default {
    name: 'studios-block',
    props: {
      items: {
        type: Array,
        default: () => [],
      },
      noFunnel: {
        type: Boolean,
        default: false,
      },
      bgColor: {
        type: String,
        default: '',
      },
      textColor: {
        type: String,
        default: '',
      },
    },
    components: {
      PageBlock,
      ChannelContent,
    },
    computed: {
      ...mapGetters('session', {
        getStudio: 'getStudio',
        getChannel: 'getChannel',
      }),
      classes() {

        return {
          'no-funnel': this.noFunnel,
        };
      },
      studio() {

        return this.getStudio(
          this.items,
        );
      },
      channel() {

        return this.getChannel(
          this.items,
        );
      },
      blockColor() {

        const color = this.studio
          && this.studio.bgColor;

        return color
          || this.bgColor
          || '';
      },
    },
  };

</script>

<style lang="scss">

  .studios-block {
    position: relative;

    /*
    &:not(.no-funnel):before {
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      content: '';
      opacity: .25;
      position: absolute;
      background-size: cover;
      background-repeat: no-repeat;
      background-image: url("/images/bg/funnel.png");
    }
    */
  }

</style>
